<script setup lang="ts">
  defineSlots<{
    default: () => unknown
  }>()
</script>

<template>
  <div class="flex items-center gap-1 text-sm font-medium">
    <slot />
  </div>
</template>
